import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useAppSelector } from '@/Application/Hooks/Redux';

import type { ISinglePayment } from '../interfaces/src/bff-web/billing/interfaces/payment-methods.interfaceV2';
import { PaymentProcessor } from '../interfaces/src/bff-web/billing/interfaces/payment-methods.interfaceV2';
import {
  setPaymentAvailable,
  setSelectedPaymentMethods
} from '../store/slices/billing';

const getGiftCardPayment = (payments?: ISinglePayment[]) => {
  if (!payments) return;
  return payments?.find(
    (method) => method?.paymentProcessor === PaymentProcessor.GIFT_CARD
  );
};

export const useClearPaymentMethod = () => {
  const billing = useAppSelector((state) => state.billing);
  const dispatch = useDispatch();
  const payments = billing?.selectedPaymentMethods?.payments;

  const clearPayment = useCallback(() => {
    const giftCardPayment = getGiftCardPayment(payments);
    if (giftCardPayment) {
      dispatch(
        setSelectedPaymentMethods({
          payments: [giftCardPayment]
        })
      );
    } else {
      dispatch(setSelectedPaymentMethods(undefined));
      dispatch(setPaymentAvailable(false));
    }
  }, [dispatch, payments]);

  return { clearPayment };
};
